import React from "react";
import { Atom, Provider } from "jotai/index";
import { errorMessage } from "../../service/service";
import LoadingBoundary from "../LoadingBoundary";
import PageSpin from "./PageSpin";

export default function WithProvider<P>(
    Component: React.ComponentType<P>,
    mapArgsToInitialProvider?: (args: P) => Array<[Atom<any>, any]>
): React.ComponentType<P> {
    return (args: P) => {
        const initialValues = mapArgsToInitialProvider?.(args) || [];

        function errorFallback(e: any) {
            return <div>{errorMessage(e)}</div>;
        }

        return (
            <LoadingBoundary
                fallback={<PageSpin />}
                errorFallback={errorFallback}>
                <Provider initialValues={initialValues}>
                    <Component {...args} />
                </Provider>
            </LoadingBoundary>
        );
    };
}
